import { UpdateEligibilityContextInput } from '../../../../../graphql';
import { Insurer } from '@getvim-os/standard';
import gql from 'graphql-tag';
import { gqlClient } from '../../../gql-client';
import { logger } from '@getvim/vim-connect-logger';
import { TransformedPatientInContextPayload } from '../../../../../standard/events';

const eligibilityContextLogger = logger.scope('Eligibility Context queries');

const UPDATE_ELIGIBILITY_CONTEXT_QUERY = gql`
  query UpdateEligibilityContext($input: UpdateEligibilityContextInput!) {
    updateEligibilityContext(input: $input) {
      transactionId
    }
  }
`;

export const getUpdateEligibilityContextInput = (
  payload: TransformedPatientInContextPayload,
  provider: UpdateEligibilityContextInput['selectedProvider'],
  encounterId: string,
): UpdateEligibilityContextInput => {
  const { demographics, insurance, patientId } = payload;
  return {
    patientId,
    encounterId,
    member: {
      firstName: demographics?.firstName,
      lastName: demographics?.lastName,
      dateOfBirth: demographics?.dateOfBirth,
      memberId: insurance!.memberId!,
    },
    selectedProvider: {
      npi: provider.npi,
      firstName: provider.firstName,
      lastName: provider.lastName,
    },
  };
};

export const updateEligibilityContext = async (
  input: UpdateEligibilityContextInput,
  insurer?: Insurer,
): Promise<string | undefined> => {
  try {
    const { data } = await gqlClient.query({
      query: UPDATE_ELIGIBILITY_CONTEXT_QUERY,
      variables: { input },
      fetchPolicy: 'no-cache',
      context: {
        uri: '/prior-auth/api/graphql',
        headers: {
          'x-insurer': insurer,
        },
      },
    });

    return data?.updateEligibilityContext?.transactionId;
  } catch (error) {
    eligibilityContextLogger.error('Failed to update eligibility', { error });
  }
};
